module.exports = __webpack_public_path__ + "static/media/i1.fd64e8c6.svg";